import React from 'react'
import { Icon } from '@iconify/react'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const AdvancedTechnologies = ({ technologies }) => {
    return (
        <SectionCard icon="mdi:robot" titleKey="advanced-technologies">
            <div className="technologies-grid">
                {technologies?.map(tech => (
                    <div key={tech.id} className="technology-card">
                        <div className="technology-icon">
                            <Icon icon={tech.icon} />
                        </div>
                        <div className="technology-content">
                            <div className="technology-name">{tech.name}</div>
                            <div className="technology-description">{tech.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </SectionCard>
    )
}

export default AdvancedTechnologies

